<template>
  <v-snackbar v-model="globalAlert.show" :timeout="globalAlert.timeout" :color="globalAlert.color">
    {{ globalAlert.message }}
    <!-- <v-btn text @click="globalAlert = false">zatvoriť</v-btn> -->
    <v-icon dark @click="globalAlert = false">mdi-close-box</v-icon>
  </v-snackbar>
</template>

<script>
export default {
  data() {
    return {};
  },
  computed: {
    globalAlert: {
      get() {
        return this.$store.getters.globalAlert;
      },
      set(value) {
        this.$store.commit("showGlobalAlert", {
          value: value,
          message: ""
        });
      }
    }
  }
};
</script>
